const equalizeSectionHeights = field => {
    const offer_summary = field.querySelector(".m-offer__summaryList");
    const notes_summary = field.querySelector(".m-offerNote__summary-wrapper");
    const condition_block = offer_summary.querySelector(".m-specialCondition");
    const note_form = notes_summary.querySelector(".m-offerNote__form");

    // If the heights of the offer section and notes section is equal do nothing
    if (notes_summary.clientHeight === offer_summary.clientHeight) return;

    // Notes section larger than offer section
    if (notes_summary.clientHeight > offer_summary.clientHeight) {
        let difference =
            notes_summary.clientHeight - offer_summary.clientHeight;
        condition_block.style.height =
            condition_block.clientHeight + difference + "px";
    } else {
        let difference =
            offer_summary.clientHeight - notes_summary.clientHeight;
        note_form.style.height = note_form.clientHeight + difference + "px";
    }
};

const removeHeightStyles = field => {
    const condition_block = field.querySelector(".m-specialCondition");
    const note_form = field.querySelector(".m-offerNote__form");

    note_form.style.height = null;
    condition_block.style.height = null;
};

const isMobileBreakpoint = () => {
    const mq = window.matchMedia("screen and (max-width: 48em)");
    return mq.matches;
};

const resizeListener = field => {
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            updateDashboard(field);
        }, 250);
    });
};

const updateDashboard = field => {
    isMobileBreakpoint()
        ? removeHeightStyles(field)
        : equalizeSectionHeights(field);
};

const noteDialogScroll = field => {
    const noteDialog = field.querySelector(".m-offerNote__dialog .mdc-dialog");
    if (noteDialog) {
        noteDialog.MDCDialog.listen("MDCDialog:opened", function() {
            const scrollEl = field.querySelector(
                ".m-offerNote__dialogContent__notes"
            );
            scrollEl.scrollTo(0, scrollEl.scrollHeight);
        });
    }
};

const noteAddedListener = field => {
    window.addEventListener("noteAdded", function() {
        setTimeout(function() {
            updateDashboard(field);
            const event = new Event("accordionContentUpdated");
            window.dispatchEvent(event);
        }, 250);
    });
};

const offerExpandedListener = field => {
    const accordion = field.querySelector('.m-accordion');
    accordion.addEventListener('accordionToggled', function() {
        setTimeout(function() {
            updateDashboard(field);
        }, 0);
    });
};

const viewOfferListener = field => {
    const viewOffer = field.querySelector('#view_offer_button');
    viewOffer.addEventListener('click', function() {
        document.querySelector("#mdc-tab-1").show();
    });
};

const initOffers = fields => {
    if (fields) {
        fields.forEach(field => {
            if (!isMobileBreakpoint()) equalizeSectionHeights(field);
            // When screen is resized: update dashboard JS
            resizeListener(field);
            // When an offer is expanded: update dashboard JS
            offerExpandedListener(field);
            // When note modals are opened, we need to scroll to the bottom of them
            noteDialogScroll(field);
            // When new notes are added, do what we need to the dashboard UI
            noteAddedListener(field);
        });
    }
};

window.addEventListener("DOMContentLoaded", () => {
    const fields = document.querySelectorAll(".o-offer");
    initOffers(fields);

    window.Livewire.hook("message.processed", (e, components) => {
        const fields = components.el.querySelectorAll(".o-offer");
        initOffers(fields);
    });
});
